import styled from "styled-components";
import { styled as materialStyled } from "@material-ui/core/styles";
import { spacing } from "@material-ui/system";
import MuiButton from "@material-ui/core/Button";
import {
    approveGreen,
    approveGreenHover,
    approveGreenDisabled,
    secondaryBlue,
    secondaryBlueClicked,
} from "styles/colors";

/**
 * Applies the spacing system to the material UI Button
 */
export const Button = materialStyled(MuiButton)(spacing);

export const ApproveButton = styled(Button)`
    background-color: ${approveGreen};
    color: white;
    border: 1px solid transparent;

    &:hover {
        background-color: ${approveGreenHover};
    }

    &:disabled {
        color: white;
        background-color: ${approveGreenDisabled};
        border: 1px solid ${approveGreenDisabled};
    }
`;

// best to set variant="outlined"
export const SecondaryButton = styled(Button)`
    color: ${secondaryBlue};
    border: 1px solid ${secondaryBlue};

    &:hover {
        background-color: ${secondaryBlue};
        color: white;
        border: 1px solid transparent;
    }

    &:active {
        background-color: ${secondaryBlueClicked};
    }
`;
